import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('ShoppingIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__shopping" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
        <path className="background" d="M25.5,51A25.5,25.5,0,1,1,51,25.5,25.53,25.53,0,0,1,25.5,51Z"/>
        <path className="foreground" d="M30.15,35.52a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,30.15,35.52Zm-12,0a2.59,2.59,0,1,0,2.6,2.59A2.6,2.6,0,0,0,18.15,35.52Zm-5.9-17.06A1.35,1.35,0,0,0,11,20.32l3.48,11.2A2.81,2.81,0,0,0,17,33.38H31.28a2.81,2.81,0,0,0,2.53-1.86l3.48-11.07,3.79-3.83h2.85a.85.85,0,0,0,.85-.85V14.24a.85.85,0,0,0-.85-.85H40.42c-.14,0-5.35,4.83-5.4,4.88a.82.82,0,0,0-.15.2H12.25Z"/>
      </svg>
    ), el);
  });
};
